module.exports = __webpack_public_path__ + "img/connect.9ea8223e.png";